import GoogleApi from 'services/GoogleApi'
import Logger from 'services/Logger'
import { GoogleEvent } from 'types/google_events'
import { isCypress } from 'utils/cypress'
import { isTestEnv } from 'utils/env'

export function deleteGoogleEvent(calendarId: string, eventId: string) {
  const url = `${calendarId}/events/${eventId}`

  Logger.debug('from google removing', url)

  return GoogleApi.instance.delete(url)
}

export function addGoogleEvent(calendarId: string, googleEvent: GoogleEvent) {
  const url = `${calendarId}/events?sendUpdates=all&conferenceDataVersion=1`

  delete googleEvent.id

  return GoogleApi.instance.post(url, { ...googleEvent })
}

export function patchGoogleEvent(calendarId: string, googleEvent: GoogleEvent) {
  return GoogleApi.instance.patch(
    `${calendarId}/events/${googleEvent.id}?sendUpdates=all&conferenceDataVersion=1`,
    googleEvent
  )
}

export function updateGoogleEvent(
  calendarId: string,
  googleEvent: GoogleEvent
) {
  return GoogleApi.instance.put(
    `${calendarId}/events/${googleEvent.id}?sendUpdates=all&conferenceDataVersion=1`,
    googleEvent
  )
}

export function findGoogleEventBySummaries(
  calendarId: string,
  summaries: string[],
  timeMin: string,
  timeMax: string
) {
  const params = new URLSearchParams({
    singleEvents: 'true',
    timeMin,
    timeMax,
    maxResults: '50'
  })

  return GoogleApi.instance
    .get(`${calendarId}/events?${params.toString()}`)
    .then((res) => {
      const items: GoogleEvent[] = res.data?.items ?? []
      const wanted = new Set(summaries)
      return items.find(
        (item) => item.summary != null && wanted.has(item.summary)
      )
    })
}

if (isTestEnv() || isCypress()) window.patchGoogleEvent = patchGoogleEvent
if (isTestEnv() || isCypress()) window.deleteGoogleEvent = deleteGoogleEvent
if (isTestEnv() || isCypress()) window.addGoogleEvent = addGoogleEvent
if (isTestEnv() || isCypress()) window.updateGoogleEvent = updateGoogleEvent
if (isTestEnv() || isCypress()) {
  window.findGoogleEventBySummaries = findGoogleEventBySummaries
}
